// extracted by mini-css-extract-plugin
module.exports = {"chart":"Chart_chart__1dNF4","chart_title":"Chart_chart_title__1AYOa","chart_time":"Chart_chart_time__3DEX1","chart_c":"Chart_chart_c__2HCsH"};